'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var DateTimeSettingsController = function DateTimeSettingsController($scope, $q, $log, DateTimeSettingsConfigService, userManagementDataService, UserManagementConstants) {
  $scope.height = 0;
  $scope.workflows = {
    common: {
      gridOptions: {
        columnDefs: DateTimeSettingsConfigService.getColumnDefs('common'),
        rowData: [],
        angularCompileRows: true,
        suppressCellSelection: true,
        rowHeight: 35
      }
    }
  };
  $scope.initialize = function () {
    if ($scope.isSystemDefault) {
      $scope.setSystemSettings();
    } else {
      $scope.setUserSettings();
    }
  };
  $scope.setUserSettings = function () {
    setData('common', _.get($scope.user, 'preferences.dateTimeNumberFormatSettings', {}), []);
  };
  $scope.setSystemSettings = function () {
    $q.all({
      systemDefaults: userManagementDataService.getDefaultDateTimeSettings(),
      timezones: userManagementDataService.getTimeZoneCodes()
    }).then(function (results) {
      setData('common', results.systemDefaults, results.timezones.codes);
    });
  };
  function close() {
    if ($scope.isOwnProfile) {
      $scope.$emit('user-profile:change-screen', UserManagementConstants.USER_PROFILE_SCREENS.USER_PROFILE);
    } else if (!$scope.isSystemDefault) {
      $scope.$emit('user-management-manage-users:change-screen', UserManagementConstants.MANAGE_USERS_SCREENS.USER_PROFILE);
    }
  }

  // time zone city codes are retrieved from the API and need to be added after other settings get loaded
  function setTimeZoneOptions(dateTimeSettings, timeZones) {
    var timeZoneSetting = _.find(dateTimeSettings, ['title', 'timeZone']);
    if (timeZoneSetting) {
      timeZoneSetting.options = _.map(timeZones, function (tz) {
        return {
          id: tz,
          label: tz
        };
      });
    }
  }
  function setData(workflow, data, timeZones) {
    var gridOptions = _.get($scope.workflows, [workflow, 'gridOptions']);
    if ($scope.workflows && $scope.workflows[workflow]) {
      var dateTimeSettings = DateTimeSettingsConfigService.getDateTimeSettings(workflow, data, $scope.isSystemDefault);
      setTimeZoneOptions(dateTimeSettings, timeZones);
      gridOptions.api.setRows(dateTimeSettings);
      gridOptions.api.onNewRows();
      $scope.calculateGridHeight(gridOptions.rowData.length);
      gridOptions.api.sizeColumnsToFit();
    }
  }
  function populateDateTimeSettings(defaultWorkflowSettings) {
    var workflowData = _.get($scope.workflows, ['common', 'gridOptions', 'rowData'], []);
    _.forEach(defaultWorkflowSettings, function (setting) {
      var currentSetting = _.find(workflowData, {
        title: setting.name
      });
      if (currentSetting) {
        currentSetting.value = {
          id: setting.value
        };
      }
    });
  }
  $scope.calculateGridHeight = function (rows) {
    $scope.height = rows * 35 + 26;
  };
  $scope.save = function () {
    var workflowSetting = {};
    _.forOwn($scope.workflows, function (workflowOptions) {
      workflowSetting = _.transform(workflowOptions.gridOptions.rowData, function (result, data) {
        result.push({
          name: data.title,
          value: data.value.id
        });
      }, []);
    });
    if (!$scope.isSystemDefault) {
      _.forEach(workflowSetting, function (value) {
        var setting = _.find($scope.user.preferences.dateTimeNumberFormatSettings, ['name', value.name]);
        if (setting) {
          setting.value = value.value;
        }
      });
      userManagementDataService.updateWorkflowSettings($scope.user, $scope.isOwnProfile).then(function () {
        toastr.success('User Date and Time settings saved');
        close();
      })["catch"](function () {
        $log.error('DateTimeSettingsController: userManagementDataService.updateWorkflowSettings - Error: User Date and Time settings not saved');
        toastr.error('Error: User Date and Time settings not saved');
      });
    } else {
      userManagementDataService.updateDateTimeSettings(workflowSetting).then(function () {
        toastr.success('System default Date and Time settings saved');
        close();
      })["catch"](function () {
        $log.error('DateTimeSettingsController: userManagementDataService.updateDateTimeSettings - Error: System default Date and Time settings not saved');
        toastr.error('Error: System default Date and Time settings not saved');
      });
    }
  };
  $scope.cancel = function () {
    close();
  };
  $scope.resetToDefault = function () {
    if (!$scope.isSystemDefault) {
      userManagementDataService.getDefaultDateTimeSettings().then(function (defaultWorkflowSettings) {
        populateDateTimeSettings(defaultWorkflowSettings);
      });
    } else {
      //Delete any modified system settings
      userManagementDataService.deleteSystemDefaultDateTimeSettings().then(setTimeout(function () {
        userManagementDataService.getDefaultDateTimeSettings().then(function (defaultWorkflowSettings) {
          populateDateTimeSettings(defaultWorkflowSettings);
        });
      }, 100));
    }
  };
};
DateTimeSettingsController.$inject = ['$scope', '$q', '$log', 'DateTimeSettingsConfigService', 'UserManagementDataService', 'UserManagementConstants'];
module.exports = DateTimeSettingsController;